import { render, staticRenderFns } from "./_lottery_code.vue?vue&type=template&id=233bc647&scoped=true&"
import script from "./_lottery_code.vue?vue&type=script&lang=js&"
export * from "./_lottery_code.vue?vue&type=script&lang=js&"
import style0 from "./_lottery_code.vue?vue&type=style&index=0&id=233bc647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bc647",
  null
  
)

export default component.exports